import { Card, UploadFile, message, Checkbox } from 'antd'
import { AdminCModal, CButton } from 'app/components/Common'
import React, { useState } from 'react'
import { COLORS } from 'app/constants'
import AnnouncementCreateImage from './AnnouncementCreateImage'
import EventInput from 'app/adminpages/AdminEvents/EventInput'
import { awsUploadImage } from 'utils/awsImageStorage'
import { useNotice } from 'app/hooks/Events/notice'
import { View } from 'styles/reactnative'
import { anyTruthy } from 'utils/ExpensiveFunction'
import { RichTextCreateEditor } from 'app/components/'

const EventCreateModal = ({ showModal, setShowModal }) => {
	const [messageApi, contextHolder] = message.useMessage()

	const { createNotice } = useNotice()
	const [images, setImages] = useState<UploadFile[]>([])
	const [title, setTitle] = useState('')
	const [content, setContent] = useState('')
	const [isFixed, setIsFixed] = useState(false)

	const AddForm = async () => {
		if (anyTruthy(title, content)) {
			if (images.length <= 25) {
				let resultImages: any = []
				if (images?.length) {
					resultImages = await Promise.all(
						images.map(async (file, index) => {
							const resultImage = await awsUploadImage(
								{ file: file?.originFileObj },
								index + 1,
								'profile',
								'user'
							)
							return resultImage
						})
					)
				}

				await createNotice({
					title: title,
					content: content,
					images: resultImages.filter(Boolean),
					isFixed: isFixed
				})
				setTitle('')
				setContent('')
				setImages([])
				setIsFixed(false)
				setShowModal(!showModal)
			} else {
				messageApi.info('이메지 25 너무면 안 됩니다.')
			}
		} else {
			messageApi.info('제목이나 내용을 추가해야 함')
		}
	}
	return (
		<AdminCModal width={1000} show={showModal} setShow={setShowModal}>
			{contextHolder}
			<Card title="공지 등록" style={{ height: '100%' }}>
				<EventInput
					value={title}
					setValue={setTitle}
					name={'제목'}
					placeholder={'제목'}
				/>

				<RichTextCreateEditor
					content={content}
					setContent={setContent}
				/>

				<View style={{ marginTop: 16 }}>
					<Checkbox checked={isFixed} onChange={e => setIsFixed(e.target.checked)}>
						고정공지로 설정
					</Checkbox>
				</View>

				{/* <AnnouncementCreateImage
					images={images}
					setImages={setImages}
				/> */}

				<View>
					<CButton
						title={'저장'}
						onClick={AddForm}
						style={{
							marginTop: 20,
							background: COLORS.primary,
							width: 200,
							height: 30,
							color: COLORS.white,
							alignSelf: 'center',
							bottom: 20,
						}}
					/>
				</View>
			</Card>
		</AdminCModal>
	)
}

export default EventCreateModal
